<template>
  <div class="page page-inner">
    <breadcrumb title="Submit Time Recording"></breadcrumb>
    <div class="card card-fluid">
      <!-- .card-body -->
      <div class="card-body">
        <div class="tab-content py-3" >
          <div class="tab-pane fade active show" >
            <div id="data-table-leave-request-request_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div class="dt-buttons btn-group">
                    <button class="btn btn-success btn-modal" v-if="detail.stat_id == 0 && action_button.submit" tabindex="0" @click="submitTimeRecording"  type="button" data-title="Request">
                      <span>Submit Time Recording</span>
                    </button>
                  </div>
                </div>
              </div>

              <b-table :items="items" :fields="fields" :sticky-header="stickyHeader" :no-border-collapse="noCollapse"  :sort-direction="sortDirection" :sort-by.sync="sortBy"
                       :sort-desc.sync="sortDesc" responsive  table-class="dt-responsive nowrap w-100 dataTable no-footer dtr-inline" hover class="table-height" :class="{'hide-scroll': isScrollHide()}">

                <template v-slot:cell(action)="row">
                  <a class="btn btn-xs "   @click="deleteRow(row.item, row.index, $event.target)" title="delete" v-if="row.item.time_id !== null && detail.stat_id == 0 && action_button.delete">
                    <em class="fa fa-trash"></em>
                  </a>
                  <a class="btn btn-xs"  @click="editRow(row.item, row.index, $event.target)" title="delete" v-if="row.item.time_id !== null && detail.stat_id == 0 && action_button.edit" >
                    <em class="fas fa-pencil-alt"></em>
                  </a>
                </template>
              </b-table>
              <div class="row align-items-center">
                <div class="col-sm-12 col-md-5">
                  <div class="dataTables_info" id="data-table-leave-request-request_info" role="status" aria-live="polite">Showing {{currentPage}} to {{perPage}} of {{rows}} entries</div>
                </div>
                <div class="col-sm-12 col-md-7 d-flex justify-content-end">
                  <div class="dataTables_paginate paging_simple_numbers">
                    <b-pagination v-model="currentPage" v-on:input="getData"  :per-page="perPage"  :total-rows="rows" ></b-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.card-body -->
    </div>
    <b-modal id="modal-update" ref="modal-update" title="Update"  @hidden="resetModal">
      <form ref="form" @submit.stop.prevent="updateRow">
        <b-form-group label="Hours" invalid-feedback="Hours is required">
          <b-form-select v-model="data.hours" :options="option_hours" :reduce="hours=>hours.value"></b-form-select>
        </b-form-group>
        <b-form-group label="Project" invalid-feedback="Project is required">
          <b-form-select v-model="data.project" :options="option_project" value-field="id" text-field="name"></b-form-select>
        </b-form-group>
        <b-form-group label="Remark" :state="remarkState" for="remarks" invalid-feedback="Remark is required">
          <b-form-textarea id="remarks" :state="remarkState" required v-model="data.remark"
                           placeholder="Enter something..." rows="3" max-rows="6"></b-form-textarea>
        </b-form-group>

      </form>
      <template v-slot:modal-footer>
        <div class="w-100">
          <button class="btn btn-primary float-right ml-1" @click="updateRow"> Update </button>
          <button class="btn btn-secondary float-right" @click="resetModal"> Cancel </button>
        </div>
      </template>
    </b-modal>
    <b-modal id="modal-delete" hide-backdrop content-class="shadow" ref="modal-delete" title="Delete" @ok="deleteItem" @hide="resetModal" ok-title="Delete" ok-variant="danger">
      <p class="my-2">
        Are you sure delete this item ?
      </p>
    </b-modal>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
import {mapGetters} from "vuex";
import {BTable, BFormTextarea, BModal, VBModal, BFormSelect, BFormGroup, BPagination, BToast} from "bootstrap-vue"
import AxiosCall from "../../../../libs/AxiosCall";
import {urlApi} from "../../../../config/url-api";
import Acl from "../../../../libs/AclButton";
export default {
  name: "SubmitTimeRecording",
  components:{
    Breadcrumb,
    BTable,
    BPagination,
    BFormGroup,
    BToast,
    BModal,
    VBModal,
    BFormTextarea,
    BFormSelect
  },
  data(){
    return {
      remarkState:false,
      noCollapse:false,
      stickyHeader: true,
      sortDirection: 'asc',
      sortBy: '',
      sortDesc: false,
      items:[],
      rows:20,
      perPage:10,
      currentPage:1,
      fields: [
        { key: 'no', sortable: true , thStyle: {maxWidth: '60px', minWidth: '10px'}},
        { key: 'action', sortable: true, thStyle: {maxWidth: '150px', minWidth: '10px'} },
        { key: 'project_name',label:'Project', sortable: true },
        { key: 'date', sortable: true },
        { key: 'time',label:'Hours', sortable: true },
        { key: 'category_name',label:'Category', sortable: true },
        { key: 'remarks', sortable: true ,thStyle: {width:'400px'}},
      ],
      data:{
        hours:"",
        project:"",
        remarks:"",
        date:""
      },
      option_hours:[],
      option_project:[],
      detail:{},
      delete_item:{},
      action_button:{
        add:false,
        edit:false,
        submit:false
      }
    }
  },
  computed:{
    ...mapGetters([ 'scrollbarHide']),
  },

  methods:{
    isScrollHide(){
      return this.scrollbarHide
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.remarkState = valid
      return valid
    },
    resetModal() {
      this.data.hours=""
      this.data.project=""
      this.data.remark=""
      this.data.date=""
      this.data.time_id=""
      this.$refs['modal-update'].hide()
    },
    deleteRow(item, index){
      this.delete_item = item
      this.$refs['modal-delete'].show()
    },
    deleteItem(){
      let payload = {
        time_id : this.delete_item.time_id
      }

      AxiosCall.Delete(urlApi.time_recording.delete_data+"/"+payload.time_id).then(res=>{
        if(res.success){
          this.successMessage(res.message)
          this.getData()
          this.$refs['modal-delete'].hide()
        }else{
          this.errorMessage(res.message)
        }

      }).catch(err =>{
        this.errorMessage(err.message)
      })
    },
    updateRow(bvModalEvt){
      bvModalEvt.preventDefault()
      if (!this.checkFormValidity()) {
        return
      }

      let payload = {
        emp_id:this.$store.getters.empId,
        date:this.data.date,
        time:this.data.hours,
        project_id:this.data.project,
        remarks:this.data.remark,
        time_id: this.data.time_id
      }
      AxiosCall.Put(payload, urlApi.time_recording.update_data).then(async res=>{
        if (res.success){
          this.successMessage(res.message)
          this.$refs['modal-update'].hide()
          this.getData()
        }else{
          this.errorMessage(res.message)
        }

      }).catch(err =>{
        this.errorMessage(err.message)
      })
    },
    editRow(item){

      this.data.hours = item.time
      this.data.project = item.project_id
      this.data.remark = item.remarks
      this.data.date = this.formatDate(item.date)
      this.data.time_id = item.time_id
      this.remarkState = null
      this.$refs['modal-update'].show()
    },
    getData(){
      this.items = []
      let firstDay = this.$route.params.first
      let lastDay = this.$route.params.last
      let payload = {emp_id: this.$store.getters.empId, start_date: firstDay, end_date: lastDay, lang: "en", company_id: "1"}
      AxiosCall.Get(payload, urlApi.time_recording.get_data).then(res => {

        if (res.success){
          this.perPage = res.total
          this.rows = res.total
          let no = (this.currentPage - 1) * this.perPage + 1
          for (let data of res.atributes){
              if (data.weekend === 1){
                data._rowVariant = 'info';
                if (data.remarks === null ) data.remarks = "Weekend";
              }
              data.no = no++
              data.date = data.date.replace("T", " ").replace("Z", "")
              this.items.push(data)
          }

        }else{
          this.errorMessage(res.message)
        }

      }).catch(e=>{
        console.log(e)
      })
    },
    successMessage(title){
      this.$bvToast.toast(title, {
        title: `Success`,
        variant: 'success',
        solid: true
      })
    },
    errorMessage(title){
      this.$bvToast.toast(title, {
        title: `Error`,
        variant: 'danger',
        solid: true
      })
    },
    formatDate(date) {
      let tgl = date.toLocaleString().split(" ")
      let d = new Date(tgl[0]),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      return [year, month, day].join('-');
    },
    getProject(){
      let firstDay = this.$route.params.first
      let payload = {emp_id: this.$store.getters.empId,period:firstDay }
      AxiosCall.Get(payload, urlApi.project.combo).then(resp=>{
        if (resp.success){
          /*  for(let data of resp.atributes){
              this.option_project.push({text:data.name, value:data.id})
            }*/
          this.option_project = resp.atributes
        }
      })
    },
    submitTimeRecording(){
      let firstDay = this.$route.params.first
      let payload = {
        emp_id:this.$store.getters.empId,
        period:firstDay,
        user_id:this.$store.getters.userId,
      }

      AxiosCall.Post(payload, urlApi.time_recording.submit_data).then(res=>{
        if (res.success){
          this.successMessage(res.message)
          this.$router.push({name:"TimeRecording"})
        }else{
          this.errorMessage(res.message)
        }
      }).catch(err=>{
        this.errorMessage(err.response.data.message)
      })
    },
    getDetail(){
      let payload = {
        period : this.$route.params.first,
        emp_id:this.$store.getters.empId
      }
      AxiosCall.Get(payload, urlApi.time_recording.detail).then(res=>{
        if(res.success){
          this.detail= {stat_id :0}
          if(res.atributes.length > 0){
            this.detail = res.atributes[0]
          }

        }else {
          this.$root.$children[0].errorMessage(res.message)
        }
      }).catch(e=>{
        this.$root.$children[0].errorMessage(e.response.data.message)
      })
    },
    checkAction(){
      for(let act in this.action_button){
        this.action_button[act] = Acl('TimeRecording', act)
      }
    }
  },
  created() {
    if(!this.$store.getters.isMultiple){
      this.fields = this.fields.filter((field)=>{
        return field.key !== 'project_name'
      })
    }
    this.checkAction()
    this.getData()
    this.getProject()
    this.getDetail()
    for (let i = 1; i <= 12; i++) {
      this.option_hours.push({text: i + " h", value: i})
    }
  }
}
</script>